import React from "/vendor/react";
import createSvgIcon from "./createSvgIcon";

const Icon =  createSvgIcon(
  <path
    d="M16.202796 11.596194L5.596194 22.202796c-.585786.585786-1.535534.585786-2.12132 0L2.06066 20.788582c-.585786-.585786-.585786-1.535534 0-2.12132L12.667262 8.06066c.585786-.585786 1.535534-.585786 2.12132 0l1.414214 1.414214c.585786.585786.585786 1.535534 0 2.12132zm-.860155-.928427L13.574874 8.9 11.1 11.374873l1.767767 1.767767 2.474874-2.474873zm7.728427-6.132233l-2.757717-.777818L19.535534 1l-.777817 2.757716L16 4.535534l2.757717.777817.777817 2.757717.777817-2.757717zm0 10l-2.757717-.777818L19.535534 11l-.777817 2.757716L16 14.535534l2.757717.777817.777817 2.757717.777817-2.757717zm-10-10l-2.757717-.777818L9.535534 1l-.777817 2.757716L6 4.535534l2.757717.777817.777817 2.757717.777817-2.757717z"
    fillRule="evenodd"
  />,
  "WandIcon",
)

export default Icon;
